// Common types
export interface BaseEntity {
  id: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export interface PaginatedResult<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

// ============================================================================
// ABC CLASSIFICATION (Inventory Management)
// ============================================================================

/**
 * ABC Classification for inventory management
 * Based on Pareto principle (80/20 rule)
 *
 * Class A: High value items - top 20% by annual value, typically 80% of inventory value
 * Class B: Medium value items - next 30% by annual value, typically 15% of inventory value
 * Class C: Low value items - bottom 50% by annual value, typically 5% of inventory value
 */
export type ABCClassification = 'A' | 'B' | 'C';

// SDUI types for Server-Driven UI (WMS Handheld Terminal)
export * from './sdui';

// WMS types (Receiving, Quality, Putaway, PO, ASN)
export * from './wms';

// TMS Route types (Route Optimization, Metrics, Metadata)
export * from './route.types';

// TMS Trip types (Trip Entity, Trip Metrics, Trip Performance)
export * from './trip.types';

// TMS Booking types (Carrier Rates, BOL, Shipment Creation)
export * from './tms';

// WMS Layout Designer types
export * from './layout-designer.types';

// AI Chatbot shared types (SpotlightStep, GuidedTourBase, SpotlightData)
export * from './chatbot.types';

// Chatbot entity-link patterns (backend ID extraction + frontend link rendering)
export * from './chatbot-entity-links';

export * from './agents';

// WebSocket namespace string constants for backend gateways + frontend hooks
export * from './ws-namespaces';

// Finance WebSocket wire-shape constants (room scope, event names, status literals)
export * from './finance-ws.types';

// Documents WebSocket wire-shape constants (approval-workflow badge surface)
export * from './documents-ws.types';
